// Componente para a aba 2 - Gerenciamento dos Prazos para envio dos comprovantes.

import React, { useState } from "react";
import axios from "axios";
import {
    Button,
    IconButton,
    Menu,
    MenuItem,
    Tooltip,
    Box,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditPrazoModal from "../modal/editPrazoModal";
import ConfirmationDialog from "../modal/confirmationDialog";

const PrazoTabAners = ({
    id,
    token,
    responsePrazos,
    responseParam,
    dataFormato,
}) => {
    console.log(responsePrazos);
    const [editPrazoData, setEditPrazoData] = useState({
        id: null,
        descricao: "",
        data: "",
        status: "",
    });
    const [showEditModal, setShowEditModal] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    // Estados para os modais de confirmação
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [selectedPrazoId, setSelectedPrazoId] = useState(null);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    // Função para deletar um prazo
    function deletePrazo(n) {
        axios
            .delete(
                `/api/remove/deadline/${n}`, // Rota simulada para excluir um prazo
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then(window.location.reload())
            .catch((error) => {
                console.error("Erro ao deletar prazo:", error);
            });
    }

    // Função para abrir o modal de criação de um novo prazo
    function modalNovoPrazo() {
        return (
            <div className="row">
                <div
                    className="col-xl-3 col-lg-4 col-md-4 div-button-success text-white"
                    title="Gerar Novo Prazo para Envio de Comprovante"
                    data-toggle="modal"
                    data-target="#prazoModal">
                    <i className="fas fa-plus"></i>Gerar Novo Prazo
                </div>
            </div>
        );
    }

    // Abre o modal de edição com os dados do prazo selecionado
    function openEditModal(prazo) {
        setEditPrazoData({
            id: prazo.id,
            descricao: prazo.descricao,
            data: prazo.data,
            status: prazo.status,
        });
        setShowEditModal(true);
    }

    function closeEditModal() {
        setShowEditModal(false);
    }

    function handleEditChange(e) {
        const { name, value } = e.target;
        setEditPrazoData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }

    // Função para editar um prazo
    function updatePrazo() {
        axios
            .put(
                `/api/update/deadline/${editPrazoData.id}`, // Rota simulada para editar um prazo
                { ...editPrazoData },
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((resp) => {
                window.location.reload()
            })
            .catch((error) => {
                console.error("Erro ao editar prazo:", error);
            });
    }

    // Função para confirmar o prazo (marcando-o como encerrado)
    function confirmPrazo(n) {
        axios
            .put(
                `/api/confirm/deadline/${n}`, // marcar status como "Encerrado" o outro status possível é "Aberto"
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((resp) => {
                window.location.reload();
            })
            .catch((error) => {
                console.error("Erro ao confirmar prazo:", error);
            });
    }

    // Abre os modais de confirmação e define o prazo selecionado
    const handleOpenConfirmModal = (prazoId) => {
        setSelectedPrazoId(prazoId);
        setOpenConfirmModal(true);
    };

    const handleOpenDeleteModal = (prazoId) => {
        setSelectedPrazoId(prazoId);
        setOpenDeleteModal(true);
    };

    // Fecha os modais e limpa o ID selecionado
    const handleCloseModals = () => {
        setOpenConfirmModal(false);
        setOpenDeleteModal(false);
        setSelectedPrazoId(null);
    };

    function ActionButtons(prazo) {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {prazo.status === "Aberto" ? (
                    <>
                        <Tooltip title="Confirmar Recebimento">
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<CheckIcon />}
                                onClick={() => handleOpenConfirmModal(prazo.id)}
                                sx={{ mr: 1 }}>
                                Confirmar
                            </Button>
                        </Tooltip>
                        <Tooltip title="Mais Ações">
                            <IconButton
                                color="primary"
                                onClick={handleMenuOpen}>
                                <MoreVertIcon />
                            </IconButton>
                        </Tooltip>
                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleMenuClose}
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}>
                            <MenuItem
                                onClick={() => {
                                    openEditModal(prazo);
                                    handleMenuClose();
                                }}>
                                <EditIcon sx={{ mr: 1 }} /> Editar
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    handleOpenDeleteModal(prazo.id);
                                    handleMenuClose();
                                }}>
                                <DeleteIcon sx={{ mr: 1 }} /> Excluir
                            </MenuItem>
                        </Menu>
                    </>
                ) : (
                    <>
                        <Tooltip title="Editar">
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<EditIcon />}
                                onClick={() => openEditModal(prazo)}
                                sx={{ mr: 1 }}>
                                Editar
                            </Button>
                        </Tooltip>
                        <Tooltip title="Excluir">
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<DeleteIcon />}
                                onClick={() => handleOpenDeleteModal(prazo.id)}
                                sx={{ mr: 1 }}>
                                Excluir
                            </Button>
                        </Tooltip>
                    </>
                )}
            </Box>
        );
    }

    return (
        <div className="tab-pane fade" id={id} role="tabpanel">
            <div className="col-12">{modalNovoPrazo()}</div>
            <div className="card-body table-responsive p-0">
                <table className="table table-bordered mt-10">
                    <thead>
                        <tr>
                            <th>Descrição</th>
                            <th>Data</th>
                            <th>Status</th>
                            <th style={{ width: 130 }}>Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {responsePrazos &&
                            responsePrazos.map((prazo) => (
                                <tr key={prazo.id}>
                                    <td>{prazo.descricao}</td>
                                    <td>{dataFormato(prazo.data)}</td>
                                    <td>{prazo.status}</td>
                                    <td>{ActionButtons(prazo)}</td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            {/* Modal de confirmação para confirmar o prazo */}
            <ConfirmationDialog
                open={openConfirmModal}
                title="Confirmar Prazo"
                message="Você tem certeza que deseja confirmar este prazo? Esta ação marcará o prazo como encerrado e não poderá ser desfeita."
                onCancel={handleCloseModals}
                onConfirm={() => {
                    confirmPrazo(selectedPrazoId);
                    handleCloseModals();
                }}
                confirmButtonColor="success"
            />

            {/* Modal de confirmação para excluir o prazo */}
            <ConfirmationDialog
                open={openDeleteModal}
                title="Excluir Prazo"
                message="Você tem certeza que deseja excluir este prazo? Esta ação não poderá ser desfeita."
                onCancel={handleCloseModals}
                onConfirm={() => {
                    deletePrazo(selectedPrazoId);
                    handleCloseModals();
                }}
                confirmButtonColor="error"
            />
            {showEditModal && (
                <EditPrazoModal
                    editPrazoData={editPrazoData}
                    handleEditChange={handleEditChange}
                    updatePrazo={updatePrazo}
                    closeEditModal={closeEditModal}
                />
            )}
        </div>
    );
};

export default PrazoTabAners;
